import { Injectable, HostListener } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppUtilityService {
  public pageTitle = '';
  // Window resize event emitter
  public windowResizeEmitter = new Subject<any>();
  windowResizeEmitter$ = this.windowResizeEmitter.asObservable();

  constructor() {}

  private readonly deviceListReg: RegExp = /iPhone|Android/i;

  public fixedEncodeURIComponent(str: string): string {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
      return '%' + c.charCodeAt(0).toString(16);
    });
  }

  public isDeviceCheck(): boolean {
    return this.isDesktop;
  }

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  public getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor;

    // Windows Phone must come first because its UA also contains 'Android'
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS';
    }

    return 'unknown';
  }

  public get isDesktop(): boolean {
    return !this.isMobile || this.tabletWindow;
  }

  public get isMobile() {
    return this.deviceListReg.test(navigator.userAgent) || this.isMobileByScreenSize;
  }

  public get isStrictlyMobile(): boolean {
    return this.isMobile && this.isMobileByScreenSize;
  }

  public get isMobileByScreenSize() {
    return window.innerWidth < 767;
  }

  public get tabletWindow(): boolean {
    if (window.innerWidth > 767 && window.innerWidth < 959) {
      return true;
    }
    // for Tablet Landscape
    if (window.innerWidth > 959) {
      return true;
    }
    return false;
  }
}
